
const digest = '3b7758c5add7e3608fb633f1078cfc100e1cf95dccfa548caf751cf66df67602';
const classes = {"wrapper":"_wrapper_1x1vk_1","controls":"_controls_1x1vk_6","content":"_content_1x1vk_13"};
const css = `._wrapper_1x1vk_1 {
  display: flex;
  flex-direction: column;
  height: 100%;
}
._wrapper_1x1vk_1 ._controls_1x1vk_6 {
  border-bottom: 1px solid #e2e5ed;
  padding: 12px;
  gap: 15px;
  display: flex;
  justify-content: space-between;
}
._wrapper_1x1vk_1 ._content_1x1vk_13 {
  flex: 1;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  